import { useState, useEffect } from 'react'

export default function LoadingScreen() {
  const [visible, setVisible] = useState(true)
  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    const t1 = setTimeout(() => setFadeOut(true), 1200)
    const t2 = setTimeout(() => setVisible(false), 1700)
    return () => { clearTimeout(t1); clearTimeout(t2) }
  }, [])

  if (!visible) return null

  return (
    <div
      className={`fixed inset-0 z-[10000] bg-black flex flex-col items-center justify-center transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      {/* Logo */}
      <img
        src="/logo-transparent.png"
        alt="ALRTZ"
        className="w-20 h-20 object-contain mb-4 logo-alive loading-glitch"
      />
      {/* Text */}
      <div className="font-display text-sm text-brand-light loading-glitch glow-text tracking-widest">
        ALRTZ
      </div>
      {/* Loading bar */}
      <div className="mt-6 w-40 h-[2px] bg-white/5 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-brand-dim via-brand-light to-neon-pink loading-bar" />
      </div>

      <style>{`
        @keyframes loadGlitch {
          0%, 100% { transform: translate(0); filter: none; }
          10% { transform: translate(-2px, 1px); filter: hue-rotate(20deg); }
          20% { transform: translate(2px, -1px); filter: hue-rotate(-20deg); }
          30% { transform: translate(0); filter: none; opacity: 0.8; }
          35% { opacity: 1; }
          50% { transform: translate(1px, -1px) skewX(-1deg); }
          60% { transform: translate(-1px, 1px) skewX(1deg); }
          70% { transform: translate(0); filter: none; }
          80% { opacity: 0.9; transform: translate(-1px, 0); }
          90% { opacity: 1; transform: translate(0); }
        }
        .loading-glitch {
          animation: loadGlitch 0.8s ease-in-out infinite;
        }
        @keyframes loadBar {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(200%); }
        }
        .loading-bar {
          animation: loadBar 1s ease-in-out infinite;
        }
      `}</style>
    </div>
  )
}
